import CardRow from '../../components/CardRow/CardRow';
import CardRowCard from '../../components/CardRow/CardRowCard';
import React from 'react';
import CustomerDetail from './components/CustomerDetail';
import { useParams } from 'react-router-dom';
import FormWrapper from '../../components/CardRow/FormWrapper';

const CustomersDetailPage = () => {
  const { id } = useParams();
  return (
    <FormWrapper>
      <CardRow>
        <CardRowCard>
          <CustomerDetail
            id={id}
          />
        </CardRowCard>
      </CardRow>
    </FormWrapper>
  );
};

export default CustomersDetailPage;
